import { render } from "./WorksView.vue?vue&type=template&id=1d3f7dde"
import script from "./WorksView.vue?vue&type=script&lang=js"
export * from "./WorksView.vue?vue&type=script&lang=js"

import "./WorksView.vue?vue&type=style&index=0&id=1d3f7dde&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__